<h2 mat-dialog-title>
  <div class="border-bottom pb-2">
       {{data?.title}}
  </div>

</h2>

<mat-dialog-content class="mat-typography">


      <div class="  px-3 py-2   " [innerHTML]="renderedHtmlContent"></div>


  </mat-dialog-content>

<div class="bookmark">
  <i class="material-icons text-primary" >
bookmark
</i>
</div>




